import React from "react";
import { Handle, Position } from "@xyflow/react";
import { FaMicrophone } from "react-icons/fa";

export default function SendVoiceNoteNode({ data, selected }) {
  return (
    <div
      className={`rounded-xl border-2 bg-surface-card shadow-sm min-w-[200px] transition-shadow ${
        selected ? "border-pink-500 shadow-md" : "border-surface-border"
      }`}
    >
      <Handle
        type="target"
        position={Position.Top}
        className="!w-3 !h-3 !bg-pink-500 !border-2 !border-white"
      />

      <div className="flex items-center gap-2 px-3 py-2 rounded-t-[10px] bg-pink-500">
        <FaMicrophone size={10} className="text-white" />
        <span className="text-xs font-semibold text-white">Voice Note</span>
      </div>

      <div className="px-3 py-2.5">
        {data.message ? (
          <p className="text-xs text-ink-muted line-clamp-2">{data.message}</p>
        ) : (
          <p className="text-xs text-ink-muted italic">Click to configure voice</p>
        )}
        {data.ttsProvider && (
          <p className="text-2xs text-ink-faint mt-1">
            via {data.ttsProvider === "elevenlabs" ? "ElevenLabs" : "OpenAI TTS"}
          </p>
        )}
      </div>

      <Handle
        type="source"
        position={Position.Bottom}
        className="!w-3 !h-3 !bg-pink-500 !border-2 !border-white"
      />
    </div>
  );
}
